import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { translate } from "react-i18next";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import List from "@material-ui/core/List";
import Select from "react-select";

const styles = theme => ({
    container: {
        alignSelf: "center",
        marginTop: 30,
        marginBottom: 0,
        width: "90%"
    },
    header: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between"
    },
    headerTitle: {
        fontSize: 16
    },
    addButton: {
        width: 35,
        height: 35,
        borderRadius: 3,
        border: "1px solid gray"
    },
    list: {},
    listItem: {
        marginBottom: 10,
        alignSelf: "center",
        alignItems: "center",
        display: "flex",
        flexDirection: "row"
    },
    selectButton: {
        flex: 1
    }
});

// NOTES: must be in ascending order
const TIMES = [
    { value: "00:00", label: "00:00" },
    { value: "00:30", label: "00:30" },
    { value: "01:00", label: "01:00" },
    { value: "01:30", label: "01:30" },
    { value: "02:00", label: "02:00" },
    { value: "02:30", label: "02:30" },
    { value: "03:00", label: "03:00" },
    { value: "03:30", label: "03:30" },
    { value: "04:00", label: "04:00" },
    { value: "04:30", label: "04:30" },
    { value: "05:00", label: "05:00" },
    { value: "05:30", label: "05:30" },
    { value: "06:00", label: "06:00" },
    { value: "06:30", label: "06:30" },
    { value: "07:00", label: "07:00" },
    { value: "07:30", label: "07:30" },
    { value: "08:00", label: "08:00" },
    { value: "08:30", label: "08:30" },
    { value: "09:00", label: "09:00" },
    { value: "09:30", label: "09:30" },
    { value: "10:00", label: "10:00" },
    { value: "10:30", label: "10:30" },
    { value: "11:00", label: "11:00" },
    { value: "11:30", label: "11:30" },
    { value: "12:00", label: "12:00" },
    { value: "12:30", label: "12:30" },
    { value: "13:00", label: "13:00" },
    { value: "13:30", label: "13:30" },
    { value: "14:00", label: "14:00" },
    { value: "14:30", label: "14:30" },
    { value: "15:00", label: "15:00" },
    { value: "15:30", label: "15:30" },
    { value: "16:00", label: "16:00" },
    { value: "16:30", label: "16:30" },
    { value: "17:00", label: "17:00" },
    { value: "17:30", label: "17:30" },
    { value: "18:00", label: "18:00" },
    { value: "18:30", label: "18:30" },
    { value: "19:00", label: "19:00" },
    { value: "19:30", label: "19:30" },
    { value: "20:00", label: "20:00" },
    { value: "20:30", label: "20:30" },
    { value: "21:00", label: "21:00" },
    { value: "21:30", label: "21:30" },
    { value: "22:00", label: "22:00" },
    { value: "22:30", label: "22:30" },
    { value: "23:00", label: "23:00" },
    { value: "23:30", label: "23:30" }
];

const emptyTimeSlot = {
    start: null,
    end: null,
    startOptions: TIMES,
    endOptions: []
};

//#region SingleSlot
class SingleSlot extends React.Component {
    render() {
        const { classes, options, defaultValue } = this.props;
        let dVal = { value: defaultValue, label: defaultValue };

        return (
            <Select
                value={dVal}
                isDisabled={this.props.options.length ? false : true}
                isSearchable={false}
                className={classes.selectButton}
                name="form-field-name"
                placeholder="..."
                onChange={newValue => this.props.onChange(newValue)}
                options={options}
            />
        );
    }
}

SingleSlot.propTypes = {
    classes: PropTypes.object.isRequired
};

const SSlot = withStyles(styles)(SingleSlot);
//#endregion SingleSlot

//#region Range
class RangeSlot extends React.Component {
    updateSlot(isStartSlot, newValue) {
        const { index, value, options } = this.props;

        let theValue = newValue ? newValue.value : null;
        if (isStartSlot) {
            var endSlotOptions = [];
            // get options for endSlot
            let foundIndex = options.findIndex(item => item.value === theValue);
            if (foundIndex < options.length - 1) {
                endSlotOptions = options.slice(foundIndex + 1);
            }

            //
            this.props.onChange(index, {
                start: theValue,
                end: value.end,
                startOptions: value.startOptions,
                endOptions: endSlotOptions
            });
        } else {
            // get options for startSlot
            let foundIndex = options.findIndex(item => item.value === theValue);
            var startSlotOptions = options.slice(0, foundIndex);

            //
            this.props.onChange(index, {
                start: value.start,
                end: theValue,
                startOptions: startSlotOptions,
                endOptions: value.endOptions
            });
        }
    }
    remove() {
        this.props.onRemoveSlot(this.props.index);
    }

    render() {
        const { classes, value } = this.props;

        function getStartOptions() {
            let foundIndex = TIMES.findIndex(item => item.value === value.end);
            let result = TIMES.slice(0, foundIndex);

            return result;
        }

        function getEndOptions() {
            let foundIndex = TIMES.findIndex(item => item.value === value.end);
            let result = TIMES.slice(foundIndex);

            return result;
        }

        let startOptions = value.startOptions
            ? value.startOptions
            : getStartOptions();
        let endOptions = value.endOptions ? value.endOptions : getEndOptions();
        return (
            <div className={classes.listItem}>
                <SSlot
                    defaultValue={value.start}
                    options={startOptions}
                    onChange={newValue => this.updateSlot(true, newValue)}
                />
                <div
                    style={{
                        flexBasis: 20,
                        textAlign: "center"
                    }}
                >
                    -
                </div>
                <SSlot
                    defaultValue={value.end}
                    options={endOptions}
                    onChange={newValue => this.updateSlot(false, newValue)}
                />
                {value.end === null ? null : (
                    <IconButton
                        color="primary"
                        style={{
                            color: "black",
                            width: 20,
                            height: 20
                        }}
                        aria-label="Close"
                        onClick={event => this.remove()}
                    >
                        <CloseIcon style={{ width: 15, height: 15 }} />
                    </IconButton>
                )}
            </div>
        );
    }
}

RangeSlot.propTypes = {
    classes: PropTypes.object.isRequired
};

const Range = withStyles(styles)(RangeSlot);
//#endregion Range

class TimeSlotsComponent extends React.Component {
    constructor(props) {
        super(props);

        let result = props.value.slice();

        let ts = props.value;
        if(this.props.emptyTimeSlot=="true"){
            ts.push(emptyTimeSlot);   
        }

        this.state = {
            availableOptions: TIMES,
            timeSlots: ts,
            result: result
        };
    }

    addEmtpyTimeSlot() {
        let ts = this.state.timeSlots;
        ts.push(emptyTimeSlot);

        this.setState({
            timeSlots: ts
        });
    }

    onChangeTimeSlot(index, newValue) {
        let ts = this.state.timeSlots;
        let theSlot = ts[index];

        ts.splice(index, 1, newValue);

        // same with result
        let rs = this.state.result;
        if (index >= rs.length) {
            rs.push(newValue);
        } else {
            rs.splice(index, 1, newValue);
        }

        this.setState({ timeSlots: ts, result: rs });

        // this.props.onUpdateTimeSlots(ts);
        this.props.onUpdateTimeSlots(rs);

        if (theSlot.end === null && newValue.end !== null) {
            this.addEmtpyTimeSlot();
        }
    }

    onRemoveSlot(index) {
        let ts = this.state.timeSlots;
        ts.splice(index, 1);

        // same with result
        let rs = this.state.result;
        rs.splice(index, 1);

        this.setState({ timeSlots: ts, result: rs });

        // this.props.onUpdateTimeSlots(ts);
        this.props.onUpdateTimeSlots(rs);
    }

    render() {
        const { t, classes } = this.props;
        const timeSlots = this.state.timeSlots;
        const self = this;

        function renderHeader() {
            return (
                <div className={classes.header}>
                    <Typography className={classes.headerTitle}>
                        {t("RangeTime")}
                    </Typography>
                </div>
            );
        }

        function renderTimeSlots() {
            function renderTimeSlotItem(index, value, onChange, onRemoveSlot) {
                return (
                    <Range
                        key={index}
                        index={index}
                        value={value}
                        options={TIMES}
                        onChange={onChange}
                        onRemoveSlot={onRemoveSlot}
                    />
                );
            }

            return (
                <List className={classes.list}>
                    {timeSlots.map((timeSlot, index) =>
                        renderTimeSlotItem(
                            index,
                            timeSlot,
                            (i, newValue) => self.onChangeTimeSlot(i, newValue),
                            i => self.onRemoveSlot(i)
                        )
                    )}
                </List>
            );
        }

        return (
            <div className={classes.container}>
                {renderHeader()}
                {renderTimeSlots()}
            </div>
        );
    }
}

export default withStyles(styles)(
    translate("translations")(TimeSlotsComponent)
);



// WEBPACK FOOTER //
// ./src/AddCampaignPage/TimeSlotsComponent.js